import { Inject, Injectable } from '@angular/core';
import { API_URL } from '../../app-store-providers';
import { HttpClient } from '@angular/common/http';
import { EntityTypes } from '../../entity/entity-types';
import { Dictionary } from '../../../shared/models/dictionary';
import { StoreBaseService } from '../../common/base.service';

@Injectable({
  providedIn: 'root'
})
export class DictionaryCarbonMaterialTypeService
  extends StoreBaseService<Dictionary> {

  get entityType(): string {
    return EntityTypes.carbonMaterialType;
  }

  get resourceName(): string {
    return 'carbon-material-type';
  }

  constructor(
    @Inject(API_URL) apiUrl: string,
    http: HttpClient
  ) {
    super(apiUrl, http);
  }
}
